const QUANTIFIED_TARGET_PATTERN =
  /\b\d+(?:\.\d+)?\s*%|\b(?:reduce|decrease|cut|lower|improve|increase|raise|drop)\b[^.]{0,60}\b\d+(?:\.\d+)?|\bfrom\b[^.]{0,40}\bto\b/i;

const BASELINE_EVIDENCE_PATTERN =
  /\b(?:baseline|validated|measured|process capability|cpk|ppk|sigma|current average|current rate|observed|actual|from)\b/i;

export function smartMeasurableHasQuantifiedTarget(value) {
  return QUANTIFIED_TARGET_PATTERN.test(value || "");
}

export function smartGoalHasBaselineEvidence(value) {
  return BASELINE_EVIDENCE_PATTERN.test(value || "");
}

export function getSmartMeasurableWarning(smartGoal) {
  if (!smartMeasurableHasQuantifiedTarget(smartGoal?.measurable)) {
    return null;
  }

  if (smartGoalHasBaselineEvidence(smartGoal?.measurable)) {
    return null;
  }

  return {
    severity: "warning",
    message:
      "This Measurable statement includes a quantified target without baseline validation. In Define, default to establishing the baseline and validating capability first, then finalize the target after Measure.",
  };
}
